// extracted by mini-css-extract-plugin
module.exports =  {"note":"_1CzEEAUzI6sos0QnyekcQs","header":"_1__3vRErCmWpyikCFMy9S6","pricing":"_2GefFHum3utx9_qVtGr7dh"};